import * as R from "ramda";
import {configLast3YearsSalesman, configLast3YearsTeamLeader, transformResponseLastThreeYearsToTable,} from "../config";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { yearOptions } from "../../config";

import { service } from '../service';
import React, { Component } from "react";
class LastThreeYearsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      dataTotal: null,
      chartVisible: false,
      chartLast3Years: null,
    };
  };

  componentDidMount = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find(item => R.equals(item.value, new Date().getFullYear())),
      tableConfig: R.equals(this.props.tab, "teamLead")
        ? configLast3YearsTeamLeader()
        : R.equals(this.props.tab, "salesman")
          ? configLast3YearsSalesman()
          : [],
    }));
  };

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    if (!R.equals(prevProps.search, this.props.search)) {
      this.setState((prevValue) => ({
        ...prevValue,
        year: yearOptions.find(item => R.equals(item.value, new Date().getFullYear())),
      }));
      this.fetchData();
    }
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading()
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhir,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Team Leader - Laporan Jualan 3 Tahun Terakhir",
        args: {
          kodeCabang: [this.props.kodeCabang?.value],
          year: this.state.year?.value,
          mode: R.equals(this.props.tab, "salesman")
            ? "SALESMAN"
            : "LEADER",
          idLeader: this.props.idLeader,
          idSalesman: null
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: transformResponseLastThreeYearsToTable(res.data.data),
        }));
      }
      this.props.triggerLoading()
    } catch (error) {
      this.props.triggerLoading()
      console.log("errors: ", error);
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  handleSearch = async () => {
    this.setState(prev=>({
      ...prev,
      tableConfig: R.equals(this.props.tab, "teamLead")
        ? configLast3YearsTeamLeader(prev.year?.value)
        : R.equals(this.props.tab, "salesman")
          ? configLast3YearsSalesman(prev.year?.value)
          : []
    }), () => this.fetchData())
  }

  render() {
    const { data, dataKey } = service.transformChartData(
      this.state.dataTable, this.state.tableConfig
    );
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            isClearable
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <>
            <SimpleDataTable
              data={this.state.dataTable}
              columns={this.state.tableConfig}
              options={{
                pagination: false,
                selectableRows: "none",
              }}
            />
          </>
        )}
        {this.state.chartVisible && (
          <CardBiaxialChart data={data} dataKey={dataKey} />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
        </FlexView>
      </>
    );
  };
}

export default LastThreeYearsReport;